import {ValidationDoc} from "@buildwitt/use-validate";
import {IGroupEntityPayload} from "@buildwitt/shapeshift-types/entities/Group";

export const cohortGroupValidationDoc: ValidationDoc<IGroupEntityPayload> = {
	title: [{
		errorMessage: "required",
		validate: e => !!e.title
	}]
}

